import {
  PaymentType,
  PAYMENT_TYPE,
} from "src/modules/domain/order/payment/paymentType/paymentType";

export type OrderSecure = Readonly<{
  order_no: string;
  user_delivery_address_id: string;
  veritrans_credit_id: number;
  used_reason: string;
  deluxe_request: string;
  payment_type: PaymentType;
  is_allowed_out_of_stock: boolean;
  total_price: number;
  html: string;
  title: string;
  is_target_ddd_authentication: boolean;
  is_takeout: boolean;
  cart_id: number;
  is_paygent: boolean;
}>;

const create = ({ ...rest }: Partial<OrderSecure> = {}): OrderSecure => ({
  order_no: "",
  user_delivery_address_id: "",
  veritrans_credit_id: 0,
  used_reason: "",
  deluxe_request: "",
  payment_type: PAYMENT_TYPE.CREDIT,
  is_allowed_out_of_stock: false,
  total_price: 0,
  html: "",
  title: "",
  is_target_ddd_authentication: false,
  is_takeout: false,
  cart_id: 0,
  is_paygent: false,
  ...rest,
});

export const OrderSecure = { create } as const;
